import { render } from "./empire.vue?vue&type=template&id=880ed6dc&scoped=true"
import script from "./empire.vue?vue&type=script&lang=js"
export * from "./empire.vue?vue&type=script&lang=js"

import "./empire.vue?vue&type=style&index=0&id=880ed6dc&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880ed6dc"]])

export default __exports__